import React from 'react';
import PropTypes from 'prop-types';

class AssignmentCardStatus extends React.Component {
  static contextTypes = {
    getFeatureFlag: PropTypes.func
  };

  render() {
    const { card } = this.props;
    const status = card.performance && card.performance.successStatus;
    const isAwaiting =
      card.contributeToSuccessStatus &&
      card.performance &&
      card.performance.completionStatus === 'COMPLETE' &&
      card.performance.successStatus === 'NA';
    let rawScore = card.performance && card.performance.rawScore;
    rawScore = Math.round(rawScore);
    const maxScore = card.performance && card.maxScore;
    const isForceCompleted = card.performance.forceComplete;

    if (!card.isGradable) return null;

    // const newObjectiveAssessment = this.context.getFeatureFlag && this.context.getFeatureFlag('new-assessment');
    const newObjectiveAssessment = true;
    if (newObjectiveAssessment && card.resource.type === 'objective') {
      return null;
    }

    if (isAwaiting) {
      return (
        <div className="assignmenStatusContainer awaitingBar">
          Awaiting Results… We’ll notify you when your grade is ready.
        </div>
      );
    }
    if (status === 'FAIL') {
      return (
        <div className="assignmenStatusContainer failBar">
          {`Uh oh, looks like you have failed this assignment. Your score: ${rawScore}/${maxScore}`}
        </div>
      );
    }
    if (status === 'PASS') {
      return (
        <div className="assignmenStatusContainer passBar">
          {`Congratulations, you have passed this assignment. ${
            isForceCompleted ? '' : `Your score: ${rawScore}/${maxScore}`
          }`}
        </div>
      );
    }
    return null;
  }
}

export default AssignmentCardStatus;
